export const toWorkItem = (p) => ({
  slug: p.shortcode,
  title: p.brandName || "Unverified brand",
  brand: p.brandCategory || "EiPi Media film",
  category: p.brandCategory,
  productionType: p.productionLabel || "Unconfirmed",
  coverLayout: p.coverLayout || "unknown",
  displayGroup: p.displayGroup || p.coverLayout || "unknown",
  coverStatus: p.coverStatus || "pending",
  posterUrl: p.coverStatus === "ready" ? p.posterUrl : null,
  posterUrlLarge: p.coverStatus === "ready" ? p.posterUrlLarge || p.posterUrl : null,
  isDemo: false,
  year: p.dateIst ? new Date(p.dateIst).getFullYear() : "",
});
